import CamundaPlatformPropertiesProvider from './CamundaPlatformPropertiesProvider';

export default {
  __init__: [ 'camundaPlatformPropertiesProvider' ],
  camundaPlatformPropertiesProvider: [ 'type', CamundaPlatformPropertiesProvider ]
};